import { connect } from 'react-redux'
import LoggedAppBar from "./logged";
import PublicAppBar from "./public";

const AppBar = ({ isLoggedIn }) => {
    return isLoggedIn ? <LoggedAppBar /> : <PublicAppBar />
}

const mapStateToProps = (state) => ({
    isLoggedIn: state.auth.isLoggedIn
})

export default connect(mapStateToProps)(AppBar);